import { memo } from "react"

const Bracketise = memo(function Bracketise({ value }) {
  return value ? `(${value})` : null
})

export { Bracketise }
